import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';

const application = (
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
const root = document.getElementById('root') as HTMLElement;
if (root.dataset.prerendered === 'true') ReactDOM.hydrateRoot(root, application);
else ReactDOM.createRoot(root).render(application);
